var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcButton',{staticClass:"new-event",attrs:{"type":"primary","aria-label":_vm.newEventButtonAriaLabel},on:{"click":_vm.newEvent},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('Plus',{attrs:{"size":20}})]},proxy:true}])},[_vm._v("\n\t"+_vm._s(_vm.$t('calendar', 'Event'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }